import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInjection: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconInjection"><Path d="M17.5 2.5L21.5 6.5" stroke="currentColor"/><Path d="M19.5 4.5L16.5 7.5" stroke="currentColor"/><Path d="M12.5 3.5L20.5 11.5" stroke="currentColor"/><Path d="M14.5 5.5L5.5 14.5L9.5 18.5L18.5 9.5" stroke="currentColor"/><Path d="M3 21L7.5 16.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconInjection;
